// Small date range helpers used by pages with Desde/Hasta filters + Hoy/Mes shortcuts.
export const isoToday = () => new Date().toISOString().slice(0, 10);
export const isoFirstDayOfMonth = () => {
  const d = new Date();
  d.setDate(1);
  return d.toISOString().slice(0, 10);
};
export const isoLastDayOfMonth = () => {
  const d = new Date();
  d.setMonth(d.getMonth() + 1);
  d.setDate(0);
  return d.toISOString().slice(0, 10);
};
export const presetHoy = () => ({ desde: isoToday(), hasta: isoToday() });
export const presetMes = () => ({ desde: isoFirstDayOfMonth(), hasta: isoLastDayOfMonth() });
